import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/Button';

const SALES_EMAIL = 'hola@lopettia.ai';
const MAILTO = `mailto:${SALES_EMAIL}?subject=${encodeURIComponent(
  'Kairos signup',
)}&body=${encodeURIComponent('Quiero probar Kairos para mi equipo.')}`;

/**
 * Interim signup surface (`/signup`).
 *
 * There is no self-serve registration yet; this page funnels prospects to
 * sales (email CTA) with paths back to the marketing landing and the login
 * screen. Standalone — no AppShell chrome.
 */
export function SignupRedirectPage() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted p-4">
      <div className="w-full max-w-md rounded-lg border bg-card p-6 text-center shadow-sm">
        <Sparkles className="mx-auto mb-3 h-8 w-8 text-primary" />
        <h1 className="mb-2 text-2xl font-semibold">{t('signup.title')}</h1>
        <p className="mb-6 text-sm text-muted-foreground">{t('signup.body')}</p>
        <a href={MAILTO}>
          <Button size="lg">{SALES_EMAIL}</Button>
        </a>
        <div className="mt-6 flex justify-center gap-4 text-xs text-muted-foreground">
          <Link to="/welcome" className="transition-colors hover:text-foreground">
            {t('signup.backToWelcome')}
          </Link>
          <span aria-hidden>·</span>
          <Link to="/login" className="transition-colors hover:text-foreground">
            {t('signup.backToLogin')}
          </Link>
        </div>
      </div>
    </div>
  );
}
